module.exports = __webpack_public_path__ + "img/249.68fe0099.jpg";